export default __webpack_public_path__ + "static/media/cat5e.54fc9051.png";